(function() {
    'use strict';
    angular.module('emarket.main.category')
      .directive('emCategoryMenu', ['$log', '$compile', '$document', '$templateCache', function($log, $compile, $document, $templateCache) {
          return {
              scope: {
                  isActive: '@active'
              },
              replace: true,
              link: function(scope, element) {
                  var template = $templateCache.get('main/category/em-category-menu/em-category-menu.tpl.html');

                  element.addClass('em-category-menu__container');
                  element.append($compile(template)(scope));
                  element.on('click', function() {
                      scope.isActive = true;
                  });


              }
          };
      }]);
}());
